import { TimelineMax, Expo, Power3 } from 'gsap';
import hades from '@/scripts/hades';
import utils from '@/scripts/utils';

export function siblingsPrevIn(el, delay) {
  const tl = new TimelineMax({
    delay,
  });

  const prev = document.querySelector('.prev__link');
  const boundingPrev = prev.getBoundingClientRect();
  const boundingEl = el.getBoundingClientRect();

  const title = el.querySelector('[data-nav] [data-siblings]');

  tl
    .addLabel('start')
    .set(title, {
      autoAlpha: 0,
    }, 'start')
    .set(el, {
      autoAlpha: 1,
    }, 'start')
    .set(prev, {
      display: 'block',
    }, 'start')
    .set(el, {
      x: boundingPrev.left - boundingEl.left,
    }, 'start')
    .to(el, 1.5, {
      x: 0,
      ease: Expo.easeInOut,
    }, 'start');

  return tl;
}

export function siblingsPrevOut(el, item, route, delay) {
  const tl = new TimelineMax({
    delay,
  });

  const title = document.querySelector(`main[js-page="${route}"] [data-siblings]`);
  const oldTitle = el.querySelector('[data-siblings]');
  const bounding = title.getBoundingClientRect();
  const prev = document.querySelector('.prev__link');

  const others = Array.from(el.querySelectorAll('[data-anim]:not([data-siblings])'))

  const scrollY = hades.ref.amount.y;

  tl
    .add('start')
    .set(item, {
      top: `+=${scrollY}`,
      display: 'block',
      transformOrigin: '0% 50%',
    }, 'start')
    .set(item.children, {
      color: '#F2F2F2',
    }, 'start')
    .set(prev, {
      display: 'none',
    }, 'start')
    .set(el, {
      position: 'absolute',
      maxWidth: '100vw',
      width: '100%',
      zIndex: 5,
      y: 0,
      pointerEvents: 'none',
    }, 'start')
    .to(oldTitle, 2.5, {
      color: '#F2F2F2',
    }, 'start')
    .to(oldTitle.parentNode, 2, {
      x: window.innerWidth / 2,
      ease: Expo.easeInOut,
    }, 'start+=0.25')
    .to(oldTitle.parentNode, 2, {
      autoAlpha: 0,
      ease: Expo.easeInOut,
    }, 'start')
    .to(others, 0.9, {
      autoAlpha: 0,
      rotationX: -8,
      ease: Expo.easeOut,
    }, 'start+=0.25')
    .to(item, 2.5, {
      left: bounding.left,
      ease: Expo.easeInOut,
    }, 'start')
    .to(item.children, 2.5, {
      color: '#474752',
    }, 'start')
    .set(el, {
      autoAlpha: 0,
    }, 'start+=1.25')

  return tl;
}